import React from "react"

// import SelectParent from "../../../../../gd-ui/select-parent/select-parent"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new";
import FieldProjects from "../projects"

// const debug = "FieldProjects_FormElementView"
const debug = false

export default function FieldProjects_FormElementView(props: FieldFormElementViewProps) {

        // @ts-ignore
        const parentsFor = props.field.parentsFor
        const value = props.model[props.field.fieldId]

        debug && console.log(debug, 'render', props, 'value=', value)

        // return <SelectParent className          = {props.className}
        //                      renderValue        = "form"
        //                      parentsFor         = {parentsFor}
        //                      multiselect        = {true}
        //                      placeholder        = {props.field.placeholder}
        //                      unselectLabel      = {unselectLabel}
        //                      companies          = {[gd.companyId]}
        //                      values             = {value ? {projects: value} : null}
        //                      showProjectIcon    = {true}
        //                      showIcon           = {true}
        //                      searchable         = {true}
        //                      disabled           = {props.disabled}
        //                      onChange           = {(data:any) => {if (props.onChange)  props.onChange(data ? data.projects : null)}}/>

        const field: FieldProjects = props.field as FieldProjects

        return <SelectParentsNew className              = {props.className}
                                 renderType             = {SelectParent_RenderType.FORM}
                                 parentsFor             = {parentsFor}
                                 placeholderIcon        = {props.field.noValueOptionIcon}
                                 placeholder            = {field.placeholder}
                                 popoverPosition        = {field.popoverPosition}
                                 unselectIcon           = {field.noValueOption ? field.noValueOptionIcon : undefined}
                                 unselectLabel          = {field.noValueOption ? field.noValueOptionLabel : undefined}
                                 displayWorkspaceRoot   = {field.displayWorkspaceRoot}
                                 projectIds             = {value ? value : null}
                                 disabled               = {props.disabled}
                                 onChange               = {(projects: ID[]) => {if (props.onChange)  props.onChange(projects ? projects : null)}}/>
}
